import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AppRouting } from '../enums';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authenticationService.isAuthorized) {
    return router.createUrlTree([`/${AppRouting.Login}`], {
      queryParams: route.queryParams,
      queryParamsHandling: 'merge',
    });
  }
  return true;
};
